import { PearlApiClient } from 'framework';
import { getAppName } from 'shared/hooks/AppName';

export function equifaxService() {
    const appName = getAppName();
    const api = PearlApiClient(appName);

    const verifyBusiness = async ({
        WebstoreName,
        ServiceAddressStreet,
        ServiceAddressCity,
        ServiceAddressState,
        ServiceAddressZipcode,
        EINNumber,
        webstore_id,
        crawledVendorId,
        copyData,
    }) => {
        const reqbody = {
            businessName: WebstoreName,
            address: ServiceAddressStreet,
            city: ServiceAddressCity,
            state: ServiceAddressState,
            postalCode: ServiceAddressZipcode,
            ein: EINNumber,
            webstoreId: webstore_id,
            crawledVendorId: crawledVendorId,
            copyData,
        };
        const res = await api.post('/verify-business', reqbody);
        return new Promise((resolve, reject) => {
            if (res?.ok) {
                resolve(res);
            } else {
                reject(res?.data?.error);
            }
        });
    };

    return {
        verifyBusiness,
    };
}
